import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import TopBar from './top-bar';
import MainHeader from './main-header';
import Banner from './banner';
import CookieBanner from './cookie-banner';
import { StyledStickyHeader } from './styled';
const Header = () => (_jsxs(_Fragment, { children: [_jsx(TopBar, {}), _jsxs(StyledStickyHeader, { children: [_jsx(CookieBanner, {}), _jsx(MainHeader, {}), _jsx(Banner, {})] })] }));
export default Header;
